import { Network } from '@aptos-labs/ts-sdk'

const IS_MAINNET = true

const MODULE_ADDRESS_TEST_NET = '0x91535f483efade11ee44e71023a87c51e73b82039269e17a3570058f3be1c82f'
const MODULE_ADDRESS_MAIN_NET = '0x53a30a6e5936c0a4c5140daed34de39d17ca7fcae08f947c02e979cef98a3719'

const TEST_CHAIN_ID = 2
const MAIN_CHAIN_ID = 1

export const MODULE_ADDRESS = IS_MAINNET ? MODULE_ADDRESS_MAIN_NET : MODULE_ADDRESS_TEST_NET
export const DECIMALS_LSD = 8
export const CHAIN_ID = IS_MAINNET ? MAIN_CHAIN_ID : TEST_CHAIN_ID
export const CHAIN_NAME = IS_MAINNET ? 'mainnet' : 'testnet'
export const DAPP_CONFIG = IS_MAINNET ? { network: Network.MAINNET } : { network: Network.TESTNET }

export const STAKE_URL = 'https://liquidswap.com/#/lsd-staking'

export * from './enums'
